import { useState } from 'react';

import { Box, TextField, Autocomplete } from '@mui/material';
import type { DocumentType } from '@/types/documentTypes';

interface DocumentTypesFieldProps {
  options: DocumentType[];
  value: DocumentType | null;
  setValue: (value: DocumentType | null | undefined) => void;
}

function DocumentTypesField({
  options,
  value,
  setValue,
}: DocumentTypesFieldProps): React.JSX.Element {
  const [selected, setSelected] = useState<DocumentType | null>(value);

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: DocumentType | null,
  ) => {
    setSelected(newValue);
    setValue(newValue ?? undefined);
  };

  return (
    <Box>
      <Autocomplete
        id='document-types-field'
        options={options}
        value={selected ?? undefined}
        sx={{ width: '100%' }}
        onChange={handleChange}
        getOptionLabel={(option) => `${option.name}`}
        disableClearable={true}
        renderInput={(params) => (
          <TextField {...params} required label='Document Types Filter' />
        )}
      />
    </Box>
  );
}

export default DocumentTypesField;

